/**
 * Standalone entry for the site chat widget.
 *
 * The marketing site (resources/views/web/2023) is Blade + Bootstrap and does
 * not load the ERP bundle -- mounting the widget through app.js would have
 * shipped ~1.5 MB of Inertia, Passport and chart code to a brochure page. This
 * entry pulls in Vue and the one component, nothing else.
 *
 * The component styles itself entirely through var(--v2-*, fallback) pairs, so
 * it renders correctly on a page that has none of the ERP's design tokens.
 */
import { createApp } from 'vue';
import axios from 'axios';
import V2ChatWidget from './Components/V2/V2ChatWidget.vue';
import '../css/site.css';
import { reservePublicNoticeSpace } from './publicNotice';

reservePublicNoticeSpace();

window.axios = window.axios || axios;

const navigation = document.getElementById('site-navigation');
const navigationToggle = document.querySelector('.dc-nav-toggle');

if (navigation && navigationToggle) {
    const mobile = window.matchMedia('(max-width: 991px)');
    let open = false;
    const setOpen = (value, restoreFocus = false) => {
        open = value;
        navigation.classList.toggle('dc-nav--open', open);
        navigation.inert = mobile.matches && !open;
        navigationToggle.setAttribute('aria-expanded', String(open));
        navigationToggle.setAttribute('aria-label', open ? 'Cerrar navegación' : 'Abrir navegación');
        if (restoreFocus) navigationToggle.focus();
    };

    document.body.classList.add('dc-navigation-ready');
    setOpen(false);
    navigationToggle.addEventListener('click', () => setOpen(!open));
    navigation.addEventListener('click', (event) => {
        if (event.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && open) setOpen(false, true);
    });
    document.addEventListener('click', (event) => {
        if (open && !event.target.closest('.dc-header')) setOpen(false);
    });
    mobile.addEventListener('change', () => setOpen(false));
}

const mount = document.getElementById('acq-chat-widget');

if (mount) {
    createApp(V2ChatWidget, {
        brand: mount.dataset.brand || 'DConsultores',
    }).mount(mount);
}
